// extracted by css-extract-rspack-plugin
export default {"cls1":"search_work_card_redesign-cls1_TcK","cls2":"search_work_card_redesign-cls2_YyF search_work_card_redesign-cls1_TcK"};